export default __webpack_public_path__ + "static/media/dashboardIconSVG.bcaf2fa6.svg";